import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, useSubmit } from 'react-router-dom'
import EmojiSquares from '../components/EmojiSquares'
import PageLayout from '../components/PageLayout'
import ProgressBar from '../components/ProgressBar'

export default function ProgressPage({
  emoji,
  title,
  subtitle,
  progressBarSubtitle,
  durationMs = 3000,
}: {
  emoji: string
  title: string
  subtitle: string
  progressBarSubtitle: string
  /** How long the loader shows before auto-advancing (ms). */
  durationMs?: number
}) {
  const PROGRESS_TIME = durationMs

  const submit = useSubmit()
  const { t } = useTranslation()

  const formRef = useRef<HTMLFormElement>(null)

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (formRef.current) {
        submit(formRef.current)
      }
    }, PROGRESS_TIME)

    return () => clearTimeout(timeout)
  }, [submit, PROGRESS_TIME])

  return (
    <PageLayout>
      <div className="flex grow flex-col justify-center">
        <EmojiSquares emoji={emoji} spin />

        <div className="mt-7 mb-12 space-y-3">
          <p className="text-custom-black text-center text-3xl font-bold text-balance">
            {t(title)}
          </p>

          <p className="text-center text-[#AFAFAF]">{t(subtitle)}</p>
        </div>

        <ProgressBar
          progressTime={PROGRESS_TIME}
          subtitle={t(progressBarSubtitle)}
        />
      </div>

      <Form method="post" ref={formRef}>
        <input
          type="hidden"
          name={t(title, { lng: 'en' })}
          value={t('shared.continue', { lng: 'en' })}
        />
      </Form>
    </PageLayout>
  )
}
